import { makeStyles, Popover, Typography } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";

const useStyles = makeStyles(
  _ => ({
    arrowDown: {
      borderLeft: "10px solid transparent",
      borderRight: "10px solid transparent",
      borderTop: "10px solid #fff",
      bottom: -10,
      height: 0,
      left: 10,
      position: "absolute",
      width: 0,
      zIndex: 2
    },
    arrowUp: {
      borderBottom: "10px solid #fff",
      borderLeft: "10px solid transparent",
      borderRight: "10px solid transparent",
      height: 0,
      left: 10,
      position: "absolute",
      top: -10,
      width: 0,
      zIndex: 2
    },
    link: {
      "&:hover": {
        textDecoration: "none"
      },
      textDecoration: "none"
    },
    linkText: {
      "&:hover": {
        fontWeight: "bold",
        textDecoration: "none"
      },
      color: "#247CFF",
      cursor: "pointer",
      padding: "5px 2px"
    },
    menu: {
      backgroundColor: "#fff",
      borderRadius: 12,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      maxWidth: 480,
      minWidth: 80,
      overflow: "visible",
      padding: "8px 15px",
      position: "relative"
    },
    popoverPaper: {
      background: "transparent",
      borderRadius: 12,
      maxWidth: 480,
      minWidth: 80,
      overflow: "visible",
      padding: "16px 0",
      position: "relative"
    }
  }),
  { name: "BreadcrumbMoreNavigation" }
);

export interface ActionItem {
  id: string;
  label: string;
  url: string;
}

export interface BreadcrumbMoreNavigationProps {
  id: string;
  className?: string;
  items: ActionItem[];
}

const BreadcrumbMoreNavigation: React.FC<BreadcrumbMoreNavigationProps> = props => {
  const { id, className, items } = props;
  const classes = useStyles(props);
  const navigate = useNavigator();

  const handleNavigate = url => {
    navigate(url);
  };

  const [anchorModal, setAnchorModal] = React.useState(null);
  const openModal = Boolean(anchorModal);
  const [isNearBottom, setIsNearBottom] = React.useState(false);

  const handleOpen = event => {
    const rect = event.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - rect.bottom;

    setIsNearBottom(spaceBelow < 200);

    setAnchorModal(event.currentTarget);
  };

  return (
    <div className={className} id={id}>
      <div
        style={{
          color: "rgb(36, 124, 255)",
          transform: "translateY(7px)"
        }}
        onClick={handleOpen}
      >
        <MoreHorizIcon style={{ fontSize: "1.15rem" }} />
        <KeyboardArrowDownIcon style={{ fontSize: "1.25rem" }} />
      </div>

      <Popover
        id="buttonActionsPopover"
        open={openModal}
        anchorEl={anchorModal}
        onClose={() => setAnchorModal(null)}
        className={classes.popoverPaper}
        anchorOrigin={{
          horizontal: "left",
          vertical: isNearBottom ? "top" : "bottom"
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: isNearBottom ? "bottom" : "top"
        }}
        elevation={0}
        PaperProps={{
          style: {
            borderRadius: 12,
            boxShadow: "0px -2px 12px rgba(0,0,0,0.2)",
            marginBottom: isNearBottom ? 10 : 0,
            marginTop: isNearBottom ? 0 : 10,
            overflow: "visible"
          }
        }}
      >
        <div className={classes.menu}>
          <div className={isNearBottom ? classes.arrowDown : classes.arrowUp} />

          {items.map((item, index) => (
            <div key={item.id + index}>
              <Link className={classes.link}>
                <Typography
                  className={classes.linkText}
                  onClick={() => handleNavigate(item.url)}
                >
                  {item.label}
                </Typography>
              </Link>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
};
BreadcrumbMoreNavigation.displayName = "BreadcrumbMoreNavigation";
export default BreadcrumbMoreNavigation;
